<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<well-page-title title="{{'abstract-entity-contact-list-update-popup.title' | translate}}">
</well-page-title>

<div class="row m">

  <well-bp-selectable-contact-list *ngIf="contactList"
                                   [isContactListExpanded]="true"
                                   [contactList]="contactList"
                                   [(selectedContactsUuids)]="selectedContactsUuids" data-testid="bp-selectable-contact-list-select">
  </well-bp-selectable-contact-list>

  <div class="mt d-flex flex-row justify-end"
       pTooltip="{{'bp-selectable-contact-list.noContactsSelected' | translate}}"
       [tooltipDisabled]="selectedContactsUuids.length > 0"
       [tooltipStyleClass]="'popup-overlay'">
    <button pButton type="button"
            [disabled]="selectedContactsUuids.length === 0 || contactList?.length === 0"
            [label]="'abstract-entity-contact-list-update-popup.update' | translate"
            (click)="onSubmitContacts()" data-testid="on-submit-contacts-btn"></button>
  </div>
</div>


